/**
 * @generated SignedSource<<48ea73bc72d0b100e2dd03d17e9ced10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeBlocksField_whatToSee$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksFieldSections_whatToSee">;
  readonly " $fragmentType": "WhatToSeeBlocksField_whatToSee";
};
export type WhatToSeeBlocksField_whatToSee$key = {
  readonly " $data"?: WhatToSeeBlocksField_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksField_whatToSee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeBlocksField_whatToSee",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WhatToSeeBlocksFieldSections_whatToSee"
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};

(node as any).hash = "cec8dd97069c529871628f5d449e2f0e";

export default node;
